export const toIloswWAndData = (aIloscW: number, aData: string) => {
    return {
      iloscW: aIloscW,
      data: aData,
    }
  }

  //szuka pierwszego okresu, gdzie ilosc dni jest wolna
  //SW 2021-04-16 //PM 2021-07-06
  export const getDate = (
    aDate: {
      iloscW: number;
      data: string;
    },
    aFilteredDates: {
      iloscW: number;
      data: string;
    }[],
    aIndex: number,
    minDays: number
  ): string | undefined => {
    //vscTest
    //console.log(aDate, aFilteredDates)
    let wReturn = true;


    if (aIndex + minDays < aFilteredDates.length)
      for (let i = 0; i < minDays; i++) {
        if (aFilteredDates[aIndex + i].iloscW === 0) {
          wReturn = false;
          break;
        }
      }
    else
      return undefined

    return wReturn ? aDate.data : getDate(aFilteredDates[aIndex + 1], aFilteredDates, aIndex + 1, minDays);
  }